import { render, staticRenderFns } from "./EntityDomainList.vue?vue&type=template&id=b58300b4&scoped=true&"
import script from "./EntityDomainList.vue?vue&type=script&lang=js&"
export * from "./EntityDomainList.vue?vue&type=script&lang=js&"
import style0 from "./EntityDomainList.vue?vue&type=style&index=0&id=b58300b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58300b4",
  null
  
)

export default component.exports